import { render, staticRenderFns } from "./passCert.vue?vue&type=template&id=41878696&scoped=true"
import script from "./passCert.vue?vue&type=script&lang=js"
export * from "./passCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41878696",
  null
  
)

export default component.exports